exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-slider-horizontal {\n  width: 100%;\n  padding: 0px;\n}\n.mat-slider-horizontal .mat-slider-wrapper {\n  left: 0;\n  right: 0;\n}\n.mat-accent .mat-slider-thumb, .mat-accent .mat-slider-thumb-label, .mat-accent .mat-slider-track-fill {\n  background-color: #000;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/pf-artfile/pf-artfile.component.css
// module id = ../../../../../src/app/mnt-invoices/pf-artfile/pf-artfile.component.css
// module chunks = common